import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../Css/Carusell.css"

const subtitles = [
    /* { text: "Soluciones Digitales ", highlight: "a tu Medida" },
    { text: "Tu proyecto, ", highlight: "sin límites." },
    { text: "Transformamos ", highlight: "ideas en resultados." },
    { highlight: "Tu mundo digital", Aftertext: ", a otro nivel." }, */
    { text: "Innovación ", highlight: "a tu Medida" },
    { highlight: "Tu Negocio, ", Aftertext: "sin límites." },
    { text: "Transformamos ", highlight: "datos en valor." },
    { text: "Servicios ", highlight: "a tu Medida" },
    { highlight: "Tu mundo online,", Aftertext: " mejorado." },

];

export default function SubtitleCarousel() {
    const [index, setIndex] = useState(0);
    const [isWideScreen, setIsWideScreen] = useState(window.innerWidth); // Set initial value to window width

    useEffect(() => {
        const handleResize = () => {
            setIsWideScreen(window.innerWidth);
        };

        // Set resize event listener
        window.addEventListener("resize", handleResize);

        // Cleanup listener when component unmounts
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % subtitles.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (


        <div className="subtihome">
            {/* Show SubtitleCarousel if screen width > 1070px, else show a line */}
            {isWideScreen > 1165 ? (
                <div
                    className="relative h-10 overflow-hidden text-center font-semibold
             text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: "5rem", fontWeight: "600" }}
                >
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={subtitles[index].text + subtitles[index].highlight}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.5 }}
                            className="absolute w-full"
                            style={{ whiteSpace: "nowrap" }}
                        >
                            {subtitles[index].text}
                            <span className="wave-text" >{subtitles[index].highlight}</span>
                            {subtitles[index].Aftertext}
                        </motion.div>

                    </AnimatePresence>
                </div>

            ) : (
                <h2 className=" subtitlesmall mt-3">
                    Soluciones {isWideScreen < 870 && (<br></br>)}<span className="wave-text" >a su Medida</span>
                </h2>
            )}
        </div>



    );
}
